import request from "@/utils/request";

export function sendContactUs(data) {
  return request({
    url: "api/contactus",
    method: "post",
    data
  });
}
